import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Modal from '../../../../components/Modal/Modal';
import Table from '../../../../components/Table/Table';
import TableHead from '../../../../components/Table/TableHead';
import TableRow from '../../../../components/Table/TableRow';
import TableHeadData from '../../../../components/Table/TableHeadData';
import TableBody from '../../../../components/Table/TableBody';
import TableData from '../../../../components/Table/TableData';
import Badge from '../../../../components/Badge/Badge';
import coOrderStatus, { coOrderStatusInfo } from '../../../../constants/coOrderStatus';
import Text from '../../../../components/Text/Text';

const modalBodyClassName = 'w-[500px] overflow-auto px-[10px]';
const tableContainerClassName = 'overflow-auto';
const tableCellClassName = 'min-w-max whitespace-nowrap px-[9px] py-0';

const CoOrderAvailabilityModal = ({ visible, toggleVisible, data: response }) => {
  const { order_id: orderId, errorData: data } = response;
  const statuses = {
    out_of_stock: coOrderStatus.OUT_OF_STOCK,
    in_stock: coOrderStatus.READY_ASB,
    in_reserved: coOrderStatus.OUT_OF_RESERVE,
  };
  const getRow = (status) => (
    data?.[status].map(({
      current_available: available, mpn, toReserve, on_the_way: onTheWay
    } = {}) => (

      <TableRow key={mpn}>
        <TableData className={tableCellClassName}>
          <Badge text={statuses[status]} type={coOrderStatusInfo[statuses[status]].state} />
        </TableData>
        <TableData className={tableCellClassName}>
          <Text text={mpn} />
        </TableData>
        <TableData className={tableCellClassName}>
          <Text text={`${toReserve}`} />
        </TableData>
        <TableData className={tableCellClassName}>
          <div className="flex justify-center items-center">
            <a
              href={`/coilovers/warehouse/?query=${mpn}`}
              className="globalLink"
              target="_blank"
              rel="noreferrer"
            >
              {available}
            </a>
          </div>
        </TableData>
        <TableData className={tableCellClassName}>
          <div className="flex justify-center items-center">
            <a
              href={`/coilovers/ordered-parts/?query=${mpn}`}
              className="globalLink"
              target="_blank"
              rel="noreferrer"
            >
              {onTheWay}
            </a>
          </div>
        </TableData>
      </TableRow>
    ))
  );

  return (
    <Modal
      visible={visible}
      toggleVisible={toggleVisible}
      title="Availability status"
      subTitle={`Order ID: ${orderId}`}
      hideSaveBtn
    >
      <div className={`${modalBodyClassName} customScroll`}>
        <div className={tableContainerClassName}>
          <Table>
            <TableHead>
              <TableRow>
                <TableHeadData>
                  status
                </TableHeadData>
                <TableHeadData>
                  MPN
                </TableHeadData>
                <TableHeadData>
                  need
                </TableHeadData>
                <TableHeadData>
                  ware
                </TableHeadData>
                <TableHeadData>
                  on the way
                </TableHeadData>
              </TableRow>
            </TableHead>
            <TableBody>
              {Object.keys(statuses)?.map((status) => data?.[status]
                && <Fragment key={status}>{getRow(status)}</Fragment>)}
            </TableBody>
          </Table>
        </div>
      </div>
    </Modal>
  );
};

CoOrderAvailabilityModal.propTypes = {
  visible: PropTypes.bool,
  toggleVisible: PropTypes.func,
  data: PropTypes.shape({
    order_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    errorData: PropTypes.shape({})
  })
};

CoOrderAvailabilityModal.defaultProps = {
  visible: false,
  toggleVisible: () => {},
  data: {}
};
export default CoOrderAvailabilityModal;
